export interface BosNotificationPathParams {
  id: number;
  uniqueId?: number;
}

const getParsedUrl = (urlPath: string): URL | null => {
  if (!urlPath) return null;

  try {
    if (/^https?:\/\//i.test(urlPath)) {
      return new URL(urlPath);
    }

    const normalizedUrl = urlPath.startsWith('/') ? urlPath : `/${urlPath}`;
    return new URL(normalizedUrl, 'https://solvace.local');
  } catch {
    return null;
  }
};

export const parseBosNotificationPath = (urlPath: string): BosNotificationPathParams | null => {
  const parsedUrl = getParsedUrl(urlPath);
  if (!parsedUrl) return null;

  const match = parsedUrl.pathname.match(/\/notification\/bos\/(\d+)$/i);
  if (!match) return null;

  const id = Number(match[1]);
  if (!Number.isFinite(id) || id <= 0) return null;

  const uniqueIdParam = parsedUrl.searchParams.get('uniqueId');
  const uniqueId = uniqueIdParam !== null ? Number(uniqueIdParam) : undefined;
  const hasValidUniqueId = uniqueId !== undefined && Number.isFinite(uniqueId) && uniqueId > 0;

  return {
    id,
    ...(hasValidUniqueId ? { uniqueId } : {}),
  };
};
